import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ModelTimelineSimple } from '../model-timeline-simple';

export class ModelTimelineSimpleBuilder {
  static fromJson(json) {
    return (json)
      ? new ModelTimelineSimple(
        json.hash,
        parseNumber(json.startTime),
        parseNumber(json.endTime),
        parseNumber(json.eventType)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ModelTimelineSimpleBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model-time-line-simple.builder.ts